<template>
  <div
    class="mx-lg-5 mx-md-8 mb-lg-4 mb-md-2 content-player-wrapper"
    style="height: auto"
  >
    <template v-if="!loading">
      <v-breadcrumbs
        class="ml-lg-10 ml-md-10 pb-2"
        :items="items"
        large
      ></v-breadcrumbs>
      <div class="border-bottom mb-2" />
      <v-row class="mx-0 px-0">
        <v-col md="12" lg="8" sm="12" class="px-0 mx-0 border-right mb-4">
          <v-btn
            :to="backLink"
            link
            outlined
            color="primary"
            small
            class="hidden-sm-and-up ml-5"
            >Back</v-btn
          >
          <h2
            :class="$vuetify.breakpoint.xs ? ['px-5'] : [' ml-lg-15 ml-md-15']"
            v-if="topic.uuid && currentLesson.title"
          >
            Lesson : {{ currentLesson.title }}
          </h2>
          <!-- video wrapper -->
          <div class="mb-1 mt-4 ml-lg-15 ml-md-15">
            <div
              :style="{
                height: $vuetify.breakpoint.xs ? '50vw' : '29vw',
                width: '99%',
              }"
              class=""
            >
              <div style="position: relative; padding-top: 52.25%">
                <iframe
                  :src="video"
                  loading="lazy"
                  style="
                    border: none;
                    position: absolute;
                    top: 0;
                    height: 100%;
                    width: 100%;
                  "
                  allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
                  allowfullscreen="true"
                ></iframe>
              </div>
            </div>
          </div>
          <div class="border-bottom mb-2" />
          <v-list-item
            class="ml-lg-10 ml-md-10"
            v-if="topic.user && topic.user.profile"
          >
            <v-list-item-avatar>
              <v-img
                v-if="topic.user.profile.avatar"
                :src="topic.user.profile.avatar"
              />
              <v-avatar color="primary" v-else>
                <span class="white--text text-h5">
                  {{ topic.user.username.charAt(0).toUpperCase() }}
                </span>
              </v-avatar>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title> {{ topic.user.username }} </v-list-item-title>
              <v-list-item-subtitle>
                {{ topic.user.profile.biography }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <div
            :class="$vuetify.breakpoint.xs ? ['px-4'] : [' ml-lg-10 ml-md-10']"
          >
            <v-tabs v-model="tab" :grow="true" align-with-title class="pa-0">
              <v-tab key="description" href="#description" class="mx-2">
                Description
              </v-tab>
              <v-tab href="#discussion" key="discussion" class="mx-2">
                Discussion
              </v-tab>
              <v-tab href="#reviews" key="reviews" class="mx-2">
                Reviews
              </v-tab>
              <v-tab href="#questions" key="questions" class="mx-2">
                Questions
              </v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab">
              <v-tab-item value="description">
                <div class="mx-7 my-5">
                  <h3>{{ topic.description }}</h3>
                </div>
              </v-tab-item>
              <v-tab-item value="discussion" class="pb-5">
                <v-row class="mx-2">
                  <v-col cols="12">
                    <v-row>
                      <v-col cols="1" class="pl-5 pt-8">
                        <div
                          :style="{
                            marginLeft: $vuetify.breakpoint.xs
                              ? 'initial'
                              : '1em',
                          }"
                        >
                          <Avatar :user="user" />
                        </div>
                      </v-col>
                      <v-col cols="10" class="pl-6">
                        <quill-editor
                          ref="myQuillEditor"
                          v-model="discussions.body"
                          :disabled="discussions.saveLoading"
                          :options="editorOptions"
                        >
                          <div id="toolbar" slot="toolbar">
                            <select class="ql-size">
                              <option value="small"></option>
                              <!-- Note a missing, thus falsy value, is used to reset to default -->
                              <option selected></option>
                              <option value="large"></option>
                              <option value="huge"></option>
                            </select>
                            <select class="ql-font">
                              <option selected="selected"></option>
                              <option value="serif"></option>
                              <option value="monospace"></option>
                            </select>
                            <!-- Add subscript and superscript buttons -->
                            <button class="image" value="image"></button>
                          </div>
                        </quill-editor>
                        <v-btn
                          :disabled="
                            !discussions.body || discussions.saveLoading
                          "
                          :loading="discussions.saveLoading"
                          :max-width="$vuetify.breakpoint.xs ? '40vw' : '10vw'"
                          class="elevation-0 mt-4"
                          color="primary"
                          small
                          @click="
                            isAuthenticated ? addDiscussion() : showAuthDialog()
                          "
                        >
                          Add Comment
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="10" offset="1" class="pl-6">
                        <Comments
                          v-if="currentLesson"
                          :isBlogs="false"
                          :commentEditBody="discussions.editBody"
                          :commentEditIndex="discussions.editIndex"
                          :commentSaveLoading="discussions.saveLoading"
                          :comments="currentLesson.discussions"
                          :isAuthenticated="isAuthenticated"
                          :updateCommentLoading="discussions.updateLoading"
                          :user="user"
                          @cancelEdit="cancelEdit"
                          @onEditorChange="onEditorChange"
                          @setDeleteMode="setDeleteMode"
                          @setEditMode="setEditMode"
                          @updateComment="updateDiscussion"
                        />
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item value="reviews" class="pb-5">
                <v-row class="mx-2">
                  <v-col cols="12">
                    <v-row>
                      <v-col cols="1" class="pl-5 pt-8">
                        <div
                          :style="{
                            marginLeft: $vuetify.breakpoint.xs
                              ? 'initial'
                              : '1em',
                          }"
                        >
                          <Avatar :user="user" />
                        </div>
                      </v-col>
                      <v-col cols="10" class="pl-6">
                        <v-rating
                          v-model="reviews.rating"
                          background-color="indigo lighten-3"
                          color="primary"
                          size="30"
                        />
                        <quill-editor
                          ref="myQuillEditor"
                          v-model="reviews.body"
                          :disabled="reviews.saveLoading"
                          :options="editorOptions"
                        >
                          <div id="toolbar" slot="toolbar">
                            <select class="ql-size">
                              <option value="small"></option>
                              <!-- Note a missing, thus falsy value, is used to reset to default -->
                              <option selected></option>
                              <option value="large"></option>
                              <option value="huge"></option>
                            </select>
                            <select class="ql-font">
                              <option selected="selected"></option>
                              <option value="serif"></option>
                              <option value="monospace"></option>
                            </select>
                            <!-- Add subscript and superscript buttons -->
                            <button class="image" value="image"></button>
                          </div>
                        </quill-editor>
                        <v-btn
                          :disabled="!reviews.rating || reviews.saveLoading"
                          :loading="reviews.saveLoading"
                          :max-width="$vuetify.breakpoint.xs ? '40vw' : '10vw'"
                          class="elevation-0 mt-4"
                          color="primary"
                          small
                          @click="
                            isAuthenticated ? addReview() : showAuthDialog()
                          "
                        >
                          Add Review
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="10" offset="1" class="pl-6">
                        <Reviews
                          v-if="reviews.topicReviews"
                          :editBody="reviews.editBody"
                          :editIndex="reviews.editIndex"
                          :saveLoading="reviews.saveLoading"
                          :reviews="reviews.topicReviews"
                          :isAuthenticated="isAuthenticated"
                          :updateLoading="reviews.updateLoading"
                          :user="user"
                          @cancelEdit="cancelEdit"
                          @setDeleteMode="setDeleteMode"
                          @setEditMode="setEditMode"
                          @updateReview="updateReview"
                        />
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item value="questions">
                <div
                  v-if="questions.length"
                  class="d-flex flex-row flex-wrap justify-space-around"
                >
                  <v-col
                    cols="12"
                    v-for="(question, index) in questions"
                    :key="index"
                  >
                    <v-card :to="`/questions/${question.uuid}`">
                      <v-card-title v-html="question.question" />
                      <div
                        class="
                          d-flex
                          flex-row flex-wrap
                          justify-space-around
                          align-center
                        "
                      >
                        <v-chip class="ma-2" color="primary" small>
                          Subject: {{ question.paper.subject.name }}
                        </v-chip>
                        <v-chip class="ma-2" color="primary" small>
                          Topic: {{ question.topic.title }}
                        </v-chip>
                        <v-chip
                          class="ma-2"
                          color="red"
                          text-color="white"
                          small
                        >
                          Grade: {{ question.paper.grade_level.grade }}
                        </v-chip>
                        <v-chip
                          class="ma-2"
                          color="green"
                          text-color="white"
                          small
                        >
                          {{ question.paper.exam_body.name }}:
                          {{ new Date(question.paper.year).getFullYear() }}
                        </v-chip>
                        <v-chip
                          class="ma-2"
                          color="green"
                          text-color="white"
                          small
                        >
                          Section: {{ question.section.section }}
                        </v-chip>
                      </div>
                    </v-card>
                  </v-col>
                </div>
                <div class="d-flex flex-row align-center justify-center mt-2">
                  <v-btn to="/questions" color="primary" small
                    >go to questions page</v-btn
                  >
                </div>
              </v-tab-item>
            </v-tabs-items>
          </div>
        </v-col>
        <v-col md="12" lg="4" sm="12" class="mb-5">
          <div class="border-bottom mb-2 hidden-sm-and-up" />
          <div :class="$vuetify.breakpoint.xs ? ['px-4'] : ['mx-3']">
            <v-btn
              :to="backLink"
              link
              outlined
              color="primary"
              class="hidden-sm-and-down"
              >Back</v-btn
            >
            <v-list nav dense v-if="lessons.length">
              <v-list-item-group color="primary">
                <v-list-item
                  v-for="(lesson, index) in lessons"
                  :key="index"
                  @click="setSelectedVideo(index)"
                  :class="{
                    active: selectedLessonIndex === index,
                  }"
                >
                  <v-list-item-icon>
                    <v-icon
                      color="primary"
                      v-if="selectedLessonIndex === index"
                    >
                      mdi-pause-circle
                    </v-icon>
                    <template v-else>
                      <v-icon color="green" v-if="lesson.completed">
                        mdi-check-circle</v-icon
                      >
                      <v-icon color="primary" v-else> mdi-play-circle </v-icon>
                    </template>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title
                      v-text="lesson.title"
                    ></v-list-item-title>
                    <v-progress-linear
                      :value="
                        (lesson.watching_session.watched_duration /
                          lesson.video_length) *
                        100
                      "
                    />
                  </v-list-item-content>

                  <v-list-item-action>
                    <v-list-item-title>{{
                      convertToHM(lesson.video_length)
                    }}</v-list-item-title>
                  </v-list-item-action>
                </v-list-item>
              </v-list-item-group>
            </v-list>
            <NoData v-else title="" subtitle="No lessons Found" />
          </div>
        </v-col>
      </v-row>
    </template>
    <div class="loader" v-else>
      <FullScreenLoader />
    </div>
    <DeleteItem
      :deleteDialog="showDeleteDialog"
      :deleteLoading="deleteLoading"
      @cancelDelete="showDeleteDialog = false"
      @deleteItem="handleDelete"
      :deleteType="deleteType"
    />
  </div>
</template>

<script>
import FullScreenLoader from "@/components/FullScreenLoader.vue";
import NoData from "@/components/NoData.vue";
import Comments from "@/components/Comments.vue";
import Reviews from "@/components/Reviews.vue";
import DeleteItem from "@/components/DeleteItem";
import Avatar from "@/components/Avatar";
import logo from "@/assets/logo-main.png";
import { mapGetters } from "vuex";
import authDialogMixin from "@/mixins/authDialogMixin";
import studyImage from "@/assets/study.jpg";

export default {
  name: "ContentPlayer",
  mixins: [authDialogMixin],
  components: {
    FullScreenLoader,
    NoData,
    Comments,
    DeleteItem,
    Avatar,
    Reviews,
  },
  metaInfo() {
    return {
      title: `Guiomentor -  Video`,
      url: window.location.href,
      description: ``,
    };
  },
  data() {
    return {
      playerOptions: {
        id: "lesson-video",
        muted: false,
        language: "en",
        autoplay: false,
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [],
        poster: logo,
      },
      noVideoOptions: {
        muted: false,
        language: "en",
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [
          {
            type: "video/mp4",
            src: "https://www.youtube.com/watch?v=AYDIjbNu7aY",
          },
        ],
        poster: logo,
      },
      topicUuid: null,
      studyImage,
      logo,
      loading: false,
      tab: null,
      selectedVideo: 0,
      selectedTopicIndex: 0,
      selectedLessonIndex: 0,
      lessons: [],
      playing: false,
      topic: {
        title: "",
        sub_topic: [],
        user: {
          profile: {},
          username: "",
        },
        grade_level: {},
        subject: {},
      },
      loadingQuestions: false,
      questions: [],
      playerReady: false,
      items: [],
      showDeleteDialog: false,
      deleteLoading: false,
      deleteType: "",
      discussions: {
        body: null,
        saveLoading: false,
        editBody: null,
        editIndex: null,
        updateLoading: false,
        isEditing: false,
        deleteIndex: null,
        showDeleteDialog: false,
      },
      reviews: {
        topicReviews: [],
        rating: null,
        body: null,
        saveLoading: false,
        editBody: null,
        editIndex: null,
        updateLoading: false,
        isEditing: false,
        deleteIndex: null,
      },

      editorOptions: {
        theme: "snow",
        modules: {
          toolbar: {
            container: [
              ["link", "image", "video"],
              ["bold", "italic", "underline"],
              ["blockquote", "code-block"],
            ],
          },
        },
      },
    };
  },
  computed: {
    ...mapGetters({
      isAuthenticated: "auth/GET_IS_AUTHENTICATED",
      user: "auth/GET_USER",
    }),
    video() {
      const videoUrl =
        this.lessons[this.selectedLessonIndex]?.video_link || '';
      return videoUrl;
    },
    backLink() {      
      return `/learning/${this.topic?.uuid}/${this.$router.history?.current?.params?.subTopicId}/lessons`;
    },
    player() {
      return this.$refs.videoPlayer.player;
    },
    panel: {
      get: function () {
        const subTopics = [];
        this.topic.sub_topic.forEach((_, index) => subTopics.push(index));
        return subTopics;
      },
      set: function (panels) {
        return panels;
      },
    },
  },
  asyncComputed: {
    currentLesson: {
      get: async function () {
        const selectedLesson =
          this.lessons[
            this.selectedLessonIndex
          ];
        if (selectedLesson >= 0) {
          selectedLesson.discussions = await this.getLessonDiscussions(
            selectedLesson
          );
          return selectedLesson;
        } else return {};
      },
      set: async function (setLesson) {
        if (setLesson) {
          setLesson.discussions = await this.getLessonDiscussions(setLesson);
          return setLesson;
        } else return {};
      },
    },
  },
  methods: {
    async setSelectedVideo(lessonIndex = 0) {
      this.selectedLessonIndex = lessonIndex;
      this.currentLesson = this.lessons[lessonIndex];
      await this.loadQuestions(this.lessons[lessonIndex]?.uuid);
      const topicUuid = this.$router.history?.current?.params?.topicId;
      const subTopicUuid = this.$router.history?.current?.params?.subTopicId;
      const url = `/watch/${topicUuid}/${subTopicUuid}/${this.lessons[lessonIndex]?.uuid}/`;
      history.pushState({}, null, url);
      this.playing = false;
      this.playerOptions = {
        ...this.playerOptions,
        sources: [
          {
            type: "video/mp4",
            src: this.lessons[lessonIndex]?.video_link || "",
          },
        ],
      };
      this.items = [
        {
          text: "Learning",
          disabled: false,
          href: "/learning",
        },
        {
          text: this.topic.grade_level.grade,
          href: "/learning",
        },
        {
          text: this.topic.subject.name,
          href: '#',
        },
        // {
        //   text: this.topic.title,
        //   href: `/learning/${this.topic.uuid}/${this.topic.sub_topic[topicIndex].uuid}/lessons`,
        // },
        {
          text: this.currentLesson?.title,
        },
      ];
    },
    async loadQuestions(uuid) {
      try {
        this.loadingQuestions = true;
        const { data } = await this.axios.get(
          `qb/questions/?topic=${uuid}&limit=6`
        );
        if (data.results) this.questions = data.results;
      } catch (e) {
        this.$snackbar.showMessage({
          content: "Couldn't load questions for this lesson",
          color: "error",
        });
      }
    },
    async getLessonDiscussions(selectedLesson) {
      const { data } = await this.axios.get(
        `topics/discussions/${selectedLesson.uuid}`
      );
      return data.results;
    },
    async addDiscussion() {
      try {
        if (this.discussions.isEditing) {
          this.cancelEdit();
        }
        this.discussions.saveLoading = true;
        const { data } = await this.axios.post(
          `topics/discussions/create/${this.currentLesson.uuid}/`,
          { message: this.discussions.body }
        );
        this.currentLesson.discussions = [
          data,
          ...this.currentLesson.discussions,
        ];
        this.discussions.body = null;
        this.$snackbar.showMessage({
          content: "Your comment was added successfully",
          color: "success",
        });
      } catch (error) {
        this.$snackbar.showMessage({
          content: this.$t("errors.somethingWentWrongError"),
          color: "error",
        });
      } finally {
        this.discussions.saveLoading = false;
      }
    },
    async updateDiscussion() {
      try {
        this.discussions.updateLoading = true;
        const postData = {
          message: this.discussions.editBody,
        };
        const uuid =
          this.currentLesson.discussions[this.discussions.editIndex].uuid;
        const { data } = await this.axios.patch(
          `topics/discussions/${uuid}/`,
          postData
        );
        const discussions = this.currentLesson.discussions;
        discussions[this.discussions.editIndex] = data;
        this.currentLesson.discussions = [...discussions];
        this.cancelEdit();
        this.$snackbar.showMessage({
          content: "Your comment was updated successfully",
          color: "success",
        });
      } catch (error) {
        this.$snackbar.showMessage({
          content: this.$t("errors.somethingWentWrongError"),
          color: "error",
        });
      } finally {
        this.discussions.updateLoading = false;
      }
    },

    async deleteDiscussion() {
      try {
        this.deleteLoading = true;
        const uuid =
          this.currentLesson.discussions[this.discussions.deleteIndex].uuid;
        await this.axios.delete(`topics/discussions/${uuid}/`);
        this.currentLesson.discussions = [
          ...this.currentLesson.discussions.filter(
            (_, i) => i !== this.discussions.deleteIndex
          ),
        ];
        this.discussions.deleteIndex = null;
        this.deleteDialog = false;
        this.$snackbar.showMessage({
          content: "Your comment was deleted successfully",
          color: "success",
        });
      } catch (error) {
        this.$snackbar.showMessage({
          content: this.$t("errors.somethingWentWrongError"),
          color: "error",
        });
      } finally {
        this.deleteLoading = false;
        this.showDeleteDialog = false;
      }
    },

    onEditorChange(val) {
      this.discussions.editBody = val;
    },

    async getTopicReviews() {
      const { data } = await this.axios.get(`topics/reviews/${this.topicUuid}`);
      return data.results;
    },
    async addReview() {
      try {
        if (this.reviews.isEditing) {
          this.cancelEdit();
        }
        this.reviews.saveLoading = true;
        const postData = {
          rating: this.reviews.rating,
          review_subject: this.topic.description,
          review_body: this.reviews.body,
        };
        const { data } = await this.axios.post(
          `topics/reviews/${this.topicUuid}/`,
          postData
        );
        const reviewerExists = this.reviews.topicReviews.find(
          (rv) => rv?.reviewer?.uuid === this.user.uuid
        );
        if (reviewerExists) {
          this.reviews.topicReviews = this.reviews.topicReviews.map((rv) => {
            if (rv.reviewer.uuid === this.user.uuid) return data.review;
            else return rv;
          });
        } else {
          this.reviews.topicReviews = [
            data.review,
            ...this.reviews.topicReviews,
          ];
        }
        this.reviews.body = null;
        this.reviews.rating = null;
        this.$snackbar.showMessage({
          content: "Your review was added successfully",
          color: "success",
        });
      } catch (error) {
        this.$snackbar.showMessage({
          content: this.$t("errors.somethingWentWrongError"),
          color: "error",
        });
      } finally {
        this.reviews.saveLoading = false;
      }
    },

    async updateReview({ body, rating }) {
      try {
        this.reviews.updateLoading = true;
        const postData = {
          rating,
          review_subject: this.topic.description,
          review_body: body,
        };
        const { data } = await this.axios.post(
          `topics/reviews/${this.topicUuid}/`,
          postData
        );
        this.reviews.topicReviews[this.reviews.editIndex] = data.review;
        this.cancelEdit();
        this.$snackbar.showMessage({
          content: "Your review was updated successfully",
          color: "success",
        });
      } catch (error) {
        this.$snackbar.showMessage({
          content: this.$t("errors.somethingWentWrongError"),
          color: "error",
        });
      } finally {
        this.reviews.updateLoading = false;
      }
    },

    async deleteReview() {
      try {
        this.deleteLoading = true;
        await this.axios.delete(`topics/reviews/${this.topicUuid}/`);
        this.reviews.topicReviews = [
          ...this.reviews.topicReviews.filter(
            (_, i) => i !== this.reviews.deleteIndex
          ),
        ];
        this.reviews.deleteIndex = null;
        this.deleteDialog = false;
        this.$snackbar.showMessage({
          content: "Your review was deleted successfully",
          color: "success",
        });
      } catch (error) {
        this.$snackbar.showMessage({
          content: this.$t("errors.somethingWentWrongError"),
          color: "error",
        });
      } finally {
        this.deleteLoading = false;
        this.showDeleteDialog = false;
      }
    },

    setEditMode({ index, isReviews }) {
      if (!this[isReviews ? "reviews" : "discussions"].isEditing) {
        this[isReviews ? "reviews" : "discussions"] = {
          ...this[isReviews ? "reviews" : "discussions"],
          isEditing: true,
          editBody: isReviews
            ? this.reviews.topicReviews[index]
            : this.currentLesson.discussions[index].message,
          editIndex: index,
        };
      } else {
        this.cancelEdit();
      }
    },

    setDeleteMode({ index, isReviews }) {
      this[isReviews ? "reviews" : "discussions"].deleteIndex = index;
      this.showDeleteDialog = true;
      this.deleteType = isReviews ? "review" : "comment";
    },

    cancelEdit() {
      this.discussions = {
        ...this.discussions,
        editBody: null,
        editIndex: null,
        isEditing: false,
      };
      this.reviews = {
        ...this.reviews,
        editBody: null,
        editIndex: null,
        isEditing: false,
      };
    },

    handleDelete({ isReviews }) {
      isReviews ? this.deleteReview() : this.deleteDiscussion();
    },

    convertToHM(secs) {
      return this.$moment.utc(secs * 1000).format("HH:mm:ss");
    },

    // update watched time both at the server and frontend
    async updateVideoTime(time) {
      if (!this.isAuthenticated) return;
      const { data } = await this.axios.put(
        `/topics/watcher/${this.currentLesson.uuid}/`,
        { watched_duration: time }
      );
      this.lessons = this.lessons.map((item, i) => {
        return i !== this.selectedLessonIndex
          ? { ...item }
          : {
              ...item,
              watching_session: {
                watched_duration: data.watched_duration,
                watching_user: data.watching_user,
              },
            };
      });
    },

    async share() {
      const shareData = {
        title: "Guiomentor courses",
        text: this.topic?.title,
        url: window.location.href,
      };
      await navigator.share(shareData);
    },

    // Video player events
    onPlayerTimeupdate(player) {
      // TODO fix this using new implementation for iframe
      let lastPlayerTime = 0;
      // update only after 5 seconds
      if (player.currentTime() < lastPlayerTime + 3) return;
      this.updateVideoTime(player.currentTime());
      lastPlayerTime = player.currentTime();
    },
    onPlayerPlay() {
      this.playing = true;
    },
    onPlayerPause() {
      this.playing = false;
    },
    onPlayerEnded() {
      this.playing = false;
    },
    // player is ready
    playerReadied(player) {
      const currentLesson = this.lessons[this.selectedLessonIndex];
      const currentTime = Number(
        currentLesson.watching_session.watched_duration
      );
      player.currentTime(currentTime || 0);
    },
  },
  async mounted() {
    try {
      this.loading = true;
      this.topicUuid = this.$router.history?.current?.params?.topicId;
      const { data } = await this.axios.get(`topics/${this.topicUuid}/`);
      this.reviews.topicReviews = await this.getTopicReviews();
      this.topic = data;
      const subTopicUuid = this.$router.history?.current?.params?.subTopicId;
      const { data: lessons } = await this.axios.get(
        `topics/${subTopicUuid}/lessons`
      );
      this.lessons = lessons.results;
      const lessonUid = this.$router.history?.current?.params?.lessonId;
      const currentLessonIndex = lessons.results.findIndex((l) => l.uuid === lessonUid);
      await this.setSelectedVideo(currentLessonIndex);
    } catch (error) {
      this.loading = false;
    } finally {
      this.loading = false;
    }
  },
};
</script>

<style scoped lang="scss">
.content-player-wrapper {
  margin-top: 5em !important;
  background-color: white;
  border-radius: 1em;

  .border-top {
    border-top: 0.2em solid #f5f6f8;
  }
  .border-bottom {
    border-bottom: 0.2em solid #f5f6f8;
  }
  .border-right {
    border-right: 0.2em solid #f5f6f8;
  }
  .border-left {
    border-left: 0.2em solid #f5f6f8;
  }

  ::v-deep .v-expansion-panel {
    border: 0.15em solid #f5f6f8 !important;
    border-radius: 1em !important;
  }
}

.video-player-box {
  left: 0;
  top: 0;
  height: inherit;
  width: inherit;

  ::v-deep .vjs-poster {
    border-radius: 1em !important;
  }

  ::v-deep .vjs-control-bar {
    border-radius: 0 0 1em 1em;
  }

  ::v-deep #lesson-video,
  .lesson-video-dimensions,
  .vjs-poster,
  .vjs-tech,
  .vjs-error-display {
    height: 100%;
    width: 100%;
    border-radius: 1em !important;
  }

  ::v-deep .video-js .vjs-big-play-button {
    left: 45% !important;
    top: 45% !important;
  }
}

.loader {
  height: 100vh;
}

.active {
  background: var(--v-accent-lighten1);
}

.questions {
  overflow-y: auto;
  overflow-x: hidden;
  height: 300px;
}

::-webkit-scrollbar {
  width: 9px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 15px;
}

::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>
